import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Image from "next/image";
import { useAppContext } from "@/src/config/AppProvider";
import useSocialMediaIcons from "@/src/utils/helpers/useSocialMediaIcons";
import CookieHelper from "@/src/utils/helpers/CookieHelper";
import useLocaleFlags from "@/src/utils/helpers/useLocaleFlags";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";

const TopInfo = () => {
  const { licenceSettings } = useAppContext();
  const { getSocialMediaIcon } = useSocialMediaIcons();
  const routes = useBrowserRoutes();
  const { t } = useTranslation();

  return (
    <div className="rbt-header-top rbt-header-top-1 variation-height-50 header-space-betwween bg-color-white rbt-border-bottom d-none d-xl-block">
      <div className="container h-100">
        <div className="rbt-header-sec align-items-center">
          <div className="rbt-header-sec-col rbt-header-left">
            <div className="rbt-header-content">
              <div className="header-info">
                <ul className="rbt-information-list">
                  <li>
                    <Link href="#" style={{ cursor: "default" }}>
                      <i className="feather-map-pin"></i>
                      {licenceSettings.Address}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="header-info">
                <ul className="rbt-information-list">
                  <li>
                    <Link href="#" style={{ cursor: "default" }}>
                      <i className="feather-phone"></i>
                      {licenceSettings.PhoneNumber}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="rbt-separator"></div>
              <div className="header-info">
                <ul className="social-share-transparent">
                  {licenceSettings.SocialMediaLinks.map(social => (
                    <li key={social.IdGuid}>
                      <Link href={social.PlatformUrl} target="_blank">
                        {getSocialMediaIcon(social.PlatformName)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="rbt-header-right">
            <div className="rbt-header-content">
              <LanguageSwitcher />
            </div>
          </div>
          <div className="header-right-btn d-flex ml--30">
            <Link className="rbt-btn rbt-switch-btn btn-gradient btn-xs" href={routes.contact}>
              <span data-text={t("contactUs")}>{t("contactUs")}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const LanguageSwitcher = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { locale, locales } = router;
  const { getLocaleFlag } = useLocaleFlags();

  const handleLocaleChange = async (locale: string) => {
    CookieHelper.set("NEXT_LOCALE", locale);
  };

  return (
    <div className="header-info">
      <ul className="rbt-dropdown-menu switcher-language">
        <li className="has-child-menu">
          <span
            className="menu-item"
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 14
            }}
          >
            <Image
              src={getLocaleFlag(locale)}
              width={20}
              height={16}
              alt={locale}
              style={{
                borderRadius: "2px",
                marginRight: "5px",
                objectFit: "cover",
                width: "16px",
                height: "13px"
              }}
            />
            {t(`locales.${locale}`)}
          </span>
          <i className="right-icon feather-chevron-down"></i>
          <ul className="sub-menu">
            {locales
              ?.filter(l => l !== locale)
              .map(l => (
                <li key={l}>
                  <Link className="p-0" href={router.asPath} locale={l} onClick={() => handleLocaleChange(l)}>
                    <span className="menu-item" style={{ padding: "4px 12px" }}>
                      <Image
                        src={getLocaleFlag(l)}
                        width={20}
                        height={14}
                        alt={locale}
                        style={{
                          borderRadius: "2px",
                          marginRight: "5px",
                          objectFit: "cover",
                          width: "20px",
                          height: "14px"
                        }}
                      />
                      {t(`locales.${l}`)}
                    </span>
                  </Link>
                </li>
              ))}
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default TopInfo;
